import { cn } from "../../utils"

type Props = {
  className?: string
  size?: number
  strokeWidth?: number
}

export const FancySparkles = ({ className, size = 14, strokeWidth = 1.5 }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 11 11`}
    fill="none"
    className={cn(className)}
  >
    {
      <path
        d="M2.38574 1.25098V3.25098M9.38574 8.25098V10.251M1.38574 2.25098H3.38574M8.38574 9.25098H10.3857M5.88574 1.25098L4.92974 4.15748C4.88082 4.30623 4.79764 4.44142 4.68691 4.55215C4.57618 4.66287 4.441 4.74605 4.29224 4.79498L1.38574 5.75098L4.29224 6.70698C4.441 6.7559 4.57618 6.83908 4.68691 6.94981C4.79764 7.06054 4.88082 7.19572 4.92974 7.34448L5.88574 10.251L6.84174 7.34448C6.89067 7.19572 6.97385 7.06054 7.08457 6.94981C7.1953 6.83908 7.33049 6.7559 7.47924 6.70698L10.3857 5.75098L7.47924 4.79498C7.33049 4.74605 7.1953 4.66287 7.08457 4.55215C6.97385 4.44142 6.89067 4.30623 6.84174 4.15748L5.88574 1.25098Z"
        stroke="url(#gradient)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    }
    <defs>
      <linearGradient
        id="gradient"
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        gradientUnits="objectBoundingBox"
      >
        <animate
          attributeName="x1"
          values="50%;60%;70%;80%;90%;100%;90%;80%;70%;60%;50%;40%;30%;20%;10%;0%;10%;20%;30%;40%;50%"
          keyTimes="0;0.05;0.1;0.15;0.2;0.25;0.3;0.35;0.4;0.45;0.5;0.55;0.6;0.65;0.7;0.75;0.8;0.85;0.9;0.95;1"
          dur="2.5s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y1"
          values="0%;10%;20%;30%;40%;50%;60%;70%;80%;90%;100%;90%;80%;70%;60%;50%;40%;30%;20%;10%;0%"
          keyTimes="0;0.05;0.1;0.15;0.2;0.25;0.3;0.35;0.4;0.45;0.5;0.55;0.6;0.65;0.7;0.75;0.8;0.85;0.9;0.95;1"
          dur="2.5s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="x2"
          values="50%;40%;30%;20%;10%;0%;10%;20%;30%;40%;50%;60%;70%;80%;90%;100%;90%;80%;70%;60%;50%"
          keyTimes="0;0.05;0.1;0.15;0.2;0.25;0.3;0.35;0.4;0.45;0.5;0.55;0.6;0.65;0.7;0.75;0.8;0.85;0.9;0.95;1"
          dur="2.5s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y2"
          values="100%;90%;80%;70%;60%;50%;40%;30%;20%;10%;0%;10%;20%;30%;40%;50%;60%;70%;80%;90%;100%"
          keyTimes="0;0.05;0.1;0.15;0.2;0.25;0.3;0.35;0.4;0.45;0.5;0.55;0.6;0.65;0.7;0.75;0.8;0.85;0.9;0.95;1"
          dur="2.5s"
          repeatCount="indefinite"
        />
        <stop offset="0.12" stopColor="var(--chart-1)" />
        <stop offset="0.88" stopColor="var(--chart-3)" />
      </linearGradient>
    </defs>
  </svg>
)
